"use client";

import { useState } from "react";
import Icon from "@/components/Icon";
import { Input } from "@/components/ui/input";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";

type ViewMode = "board" | "list";

interface RoadmapViewControlsProps {
	initialView?: ViewMode;
	handleView(view: ViewMode): void;
	handleSearch(query: string): void;
}

export const RoadmapViewControls = ({
	initialView = "board",
	handleView,
	handleSearch,
}: RoadmapViewControlsProps) => {
	const [searchQuery, setSearchQuery] = useState("");

	const handleSearchQueryChange = (value: string) => {
		setSearchQuery(value);
		handleSearch(value);
	};

	return (
		<div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
			<Tabs
				defaultValue={initialView}
				onValueChange={(value) => handleView(value as ViewMode)}
			>
				<TabsList>
					<TabsTrigger value="board">
						<Icon name="Grid2x2" className="mr-1 size-4" /> Board
					</TabsTrigger>
					<TabsTrigger value="list">
						<Icon name="List" className="mr-1 size-4" /> List
					</TabsTrigger>
				</TabsList>
			</Tabs>
			<Input
				placeholder="Search issues..."
				value={searchQuery}
				onChange={(e) => handleSearchQueryChange(e.target.value)}
				className="max-w-sm"
			/>
		</div>
	);
};
